import { StyleSheet, View } from 'react-native'
import { TouchableNoFeedback } from '../../../../elements/controls'
import Icon from '../../../../elements/images/Icon'

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'center',
    alignItems: 'center',
  },
})

export const BigPlayButton = ({ scale = 4, onPress }) => (
  <View style={styles.overlay}>
    <TouchableNoFeedback onPress={onPress}>
      <Icon scale={scale} name="play-circle" />
    </TouchableNoFeedback>
  </View>
)
